/** Liber fee model — rates come from Admin → Settings (via applyFeeRules / fee-rules-service). */

export const DEFAULT_PLATFORM_FEE_PERCENT = 10;
export const DEFAULT_CLIENT_SERVICE_FEE_PERCENT = 3;
export const DEFAULT_MIN_WITHDRAWAL_AED = 100;
export const DEFAULT_MILESTONE_HOLD_DAYS = 7;

let platformFeeRate = DEFAULT_PLATFORM_FEE_PERCENT / 100;
let clientServiceFeeRate = DEFAULT_CLIENT_SERVICE_FEE_PERCENT / 100;
let minWithdrawalAed = DEFAULT_MIN_WITHDRAWAL_AED;
let milestoneHoldDays = DEFAULT_MILESTONE_HOLD_DAYS;

/** @deprecated use getPlatformFeeRate() — kept for older imports */
export let LIBER_PLATFORM_FEE_RATE = platformFeeRate;
/** @deprecated use getClientServiceFeeRate() */
export let CLIENT_SERVICE_FEE_RATE = clientServiceFeeRate;
/** @deprecated use getMinWithdrawalAed() */
export let MIN_WITHDRAWAL_AED = minWithdrawalAed;

export function applyFeeRules(rules = {}) {
  const platformPct = Number(rules.platformPercent);
  if (Number.isFinite(platformPct) && platformPct >= 0 && platformPct <= 100) {
    platformFeeRate = platformPct / 100;
    LIBER_PLATFORM_FEE_RATE = platformFeeRate;
  }
  const clientPct = Number(rules.clientServiceFeePercent);
  if (Number.isFinite(clientPct) && clientPct >= 0 && clientPct <= 100) {
    clientServiceFeeRate = clientPct / 100;
    CLIENT_SERVICE_FEE_RATE = clientServiceFeeRate;
  }
  const minWd = Number(rules.minWithdrawalAed);
  if (Number.isFinite(minWd) && minWd >= 0) {
    minWithdrawalAed = minWd;
    MIN_WITHDRAWAL_AED = minWithdrawalAed;
  }
  const holdDays = Number(rules.milestoneHoldDays);
  if (Number.isFinite(holdDays) && holdDays >= 0) {
    milestoneHoldDays = holdDays;
  }
}

export function getPlatformFeeRate() {
  return platformFeeRate;
}

export function getPlatformFeePercent() {
  return Math.round(platformFeeRate * 10000) / 100;
}

export function getClientServiceFeeRate() {
  return clientServiceFeeRate;
}

export function getMinWithdrawalAed() {
  return minWithdrawalAed;
}

export function getMilestoneHoldDays() {
  return milestoneHoldDays;
}

function roundMoney(n) {
  return Math.round(Number(n) * 100) / 100;
}

export function clientServiceFee(projectValue) {
  const v = roundMoney(projectValue);
  return roundMoney(v * getClientServiceFeeRate());
}

export function clientTotalDue(projectValue) {
  const v = roundMoney(projectValue);
  return roundMoney(v + clientServiceFee(v));
}

export function splitPlatformFee(projectValue) {
  const gross = roundMoney(projectValue);
  const rate = getPlatformFeeRate();
  if (!Number.isFinite(gross) || gross < 0) {
    return { project_value: 0, platform_fee: 0, wallet_credit: 0, platform_fee_rate: rate };
  }
  const platform_fee = roundMoney(gross * rate);
  const wallet_credit = roundMoney(gross - platform_fee);
  return { project_value: gross, platform_fee, wallet_credit, platform_fee_rate: rate };
}
